/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useContext, useEffect } from 'react';
import Alert from 'react-s-alert';
import moment from 'moment';
import { Progress, Table } from 'reactstrap';
import Joyride, { STATUS } from 'react-joyride';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// service imports
import AuthService from '../../services/AuthService';
import ClientService from '../../services/ClientService';
import GeneralService from '../../services/GeneralService';
import ChatService from '../../services/ChatService';

// local imports
import ErrorBoundary from '../general/ErrorBoundary';
import Loading from '../../assets/UW_Horizontal_Logo_Full.png';
import SelectedProvider from './SelectedProvider';
import ClientNavbar from './ClientNavbar';


const MakeSubscriptionPayment = props => {

    // contexts
    const { theme } = useContext(ThemeContext);
    const { user, setUser } = useContext(AuthContext);

    // states
    const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [totalAmount, setTotalAmount] = useState(0);
    const [GST, setGST] = useState({ percent: 0, amount: 0 });
    const [selectedProvider, setSelectedProvider] = useState({});
    const [subscriptionDetails, setSubscriptionDetails] = useState();
    const [updateDetails, setUpdateDetails] = useState({ isUpdate: false });
    const [paymentDetails, setPaymentDetails] = useState({});
    const [tutorial, setTutorial] = useState({
        status: false,
        steps: [
            {
                content: <div><h2>You can make payments using this page.</h2></div>,
                placement: 'center',
                target: '#makePaymentDiv',
            },
            {
                content: <div className="tooltipDiv">Confirm your subscription details before proceeding.</div>,
                placement: 'bottom',
                target: '#subscriptionDetails'
            },
            {
                content: <div className="tooltipDiv">Here you will see the final summary of the payment</div>,
                placement: 'top',
                target: '#finalCharges'
            },
            {
                content: <div className="tooltipDiv">Press here to proceed to our payment gateway.<br />You may use UPI, Debit card, Credit card and Netbanking to pay the amount.<br />Payments are secured and powered by Razorpay</div>,
                placement: 'top',
                target: '#bookBtn'
            }
        ]
    });
    let helpers = null;

    // useEffect
    useEffect(() => {
        if (!user.guideTakenFor.includes("MakeSubscriptionPayment")) {
            setTutorial({ ...tutorial, status: true });
        }
    }, []);

    useEffect(() => {
        try {
            setPaymentDetails({
                ...paymentDetails,
                providerEmail: selectedProvider.email
            })
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Client MakeSubscriptionPayment useEffect1', 'Error in try catch block', err.stack);
        }
    }, [selectedProvider]);

    useEffect(() => {
        if (updateDetails.isUpdate) {
            // console.log(updateDetails);
            if (updateDetails.amount.remainingDays) {
                setTotalAmount((updateDetails.amount.newAmount - updateDetails.amount.balanceAmount) / 100);
            }
            if (updateDetails.call.remaining < 0 || updateDetails.video.remaining < 0) {
                setDisableSubmitBtn(true);
            }
        }
    }, [updateDetails])

    useEffect(() => {
        try {
            if (props.location.state) {
                // console.log("states", props.location.state);
                setSelectedProvider(props.location.state.selectedProvider);
                setSubscriptionDetails(props.location.state.selectedPlan);
                if (props.location.state.isUpdate) {
                    const currentCycleTotalDays = props.location.state.oldPlan.currentCycleTotalDays;
                    const remainingDays = currentCycleTotalDays - props.location.state.oldPlan.currentCycleDaysGone;
                    const prevPerDayAmount = props.location.state.oldPlan.clientSubscriptionPlan.amount / currentCycleTotalDays;
                    const nextPerDayAmount = props.location.state.selectedPlan.amount / currentCycleTotalDays;
                    setUpdateDetails({
                        call: {
                            old: props.location.state.oldPlan.serviceDetails.call.history.length,
                            new: props.location.state.selectedPlan.call,
                            remaining: props.location.state.selectedPlan.call - props.location.state.oldPlan.serviceDetails.call.history.length
                        },
                        video: {
                            old: props.location.state.oldPlan.serviceDetails.video.history.length,
                            new: props.location.state.selectedPlan.video,
                            remaining: props.location.state.selectedPlan.video - props.location.state.oldPlan.serviceDetails.video.history.length
                        },
                        amount: {
                            old: props.location.state.oldPlan.clientSubscriptionPlan.amount,
                            new: props.location.state.selectedPlan.amount,
                            remaining: props.location.state.selectedPlan.amount - props.location.state.oldPlan.clientSubscriptionPlan.amount,
                            remainingDays: remainingDays,
                            oldPerDayAmount: prevPerDayAmount,
                            newPerDayAmount: nextPerDayAmount,
                            balanceAmount: prevPerDayAmount * remainingDays,
                            newAmount: nextPerDayAmount * remainingDays
                        },
                        razorpaySubscriptionId: props.location.state.oldPlan.razorpaySubscriptionId,
                        isUpdate: true,
                        currentCycleStartDate: props.location.state.oldPlan.currentCycleStartDate,
                        currentCycleDaysGone: props.location.state.oldPlan.currentCycleDaysGone,
                        currentCycleTotalDays: currentCycleTotalDays
                    })
                } else {
                    setTotalAmount(props.location.state.selectedPlan.amount / 100);
                }
                setIsLoading(false);
            } else {
                // console.log('props', props.history);
                props.history.replace('subscription');
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Client MakeSubscriptionPayment useEffect2', 'Error in try catch block', err.stack);
        }
    }, [props.location.state]);

    // 7043030352

    // utility functions
    const loadScript = (src) => {
        try {
            return new Promise((resolve) => {
                const script = document.createElement('script');
                script.src = src;
                script.onload = () => {
                    resolve(true);
                }
                script.onerror = () => {
                    resolve(false);
                }
                document.body.appendChild(script);
            })
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at MakePayment loadScript', err.stack);
        }
    }

    // handle functions
    const handlePlanSelect = e => {
        if (subscriptionDetails.id) {
            setDisableSubmitBtn(true);
            setIsLoading(true);
            try {
                ClientService.postRazorpayClientSubscription(
                    subscriptionDetails.razorpayPlanId,
                    1000,
                    {
                        planId: subscriptionDetails.id,
                        clientName: user.username,
                        clientEmail: user.email,
                        providerName: selectedProvider.name,
                        providerEmail: selectedProvider.email
                    }
                ).then(data => {
                    try {
                        displayRazorpay(data.response.id, "Payment against creating subscription");
                    } catch (err) {
                        setDisableSubmitBtn(false);
                        // console.log(err);
                        Alert.error("Some error occured, please try again later or report support team.", {
                            position: 'top-right',
                            effect: 'slide'
                        });
                        // GeneralService.logError('at BookSession useEffect2_1', err.stack);
                    }
                });
            } catch (err) {
                setDisableSubmitBtn(false);
                Alert.error("Some error occured, please try again later or report support team.", {
                    position: 'top-right',
                    effect: 'slide'
                });
                // GeneralService.logError('at BookSession handleSubmit', err.stack);
            }
        }
    }

    const handlePlanUpdate = e => {
        if (subscriptionDetails.id) {
            setDisableSubmitBtn(true);
            setIsLoading(true);
            try {
                ClientService.updateSubscription(updateDetails.razorpaySubscriptionId, subscriptionDetails).then(data => {
                    // console.log("data", data);
                    setIsLoading(false);
                    setDisableSubmitBtn(false);
                    props.history.push('subscription');
                }).catch(err => {
                    // console.log("err3", err);
                    setDisableSubmitBtn(false);
                    Alert.error("Some error occured, please try again later or report support team.", {
                        position: 'top-right',
                        effect: 'slide'
                    });
                });
            } catch (err) {
                // console.log("err2", err);
                setDisableSubmitBtn(false);
                Alert.error("Some error occured, please try again later or report support team.", {
                    position: 'top-right',
                    effect: 'slide'
                });
                // GeneralService.logError('at BookSession handleSubmit', err.stack);
            }
        }
    }

    const displayRazorpay = async (subscriptionId, description) => {
        try {
            const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js');

            if (!res) {
                console.log('Razorpay SDK failed to load');
                return;
            }

            const options = {
                key: "rzp_test_S5VDzRjlueD699",
                subscription_id: subscriptionId,
                name: user.email,
                description: description,
                handler: function (response) {
                    // console.log("razorpay_payment_id", response.razorpay_payment_id);
                    // console.log("razorpay_subscription_id", response.razorpay_subscription_id);
                    // console.log("razorpay_signature", response.razorpay_signature);
                    ClientService.addSubscription(response.razorpay_subscription_id, subscriptionDetails).then(data => {
                        // console.log("data", data);
                        setIsLoading(false);
                        setDisableSubmitBtn(false);
                        props.history.push('subscription');
                    });
                },
                modal: {
                    ondismiss: function () {
                        setIsLoading(false);
                        setDisableSubmitBtn(false);
                        // console.log("Checkout form closed");
                    }
                },
                prefill: {
                    name: user.username,
                    email: user.email
                    // phone_number: '9899999999'
                }
            }
            const paymentObject = new window.Razorpay(options)
            paymentObject.open()
        } catch (err) {
            setIsLoading(false);
            setDisableSubmitBtn(false);
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at MakePayment displayRazorpay', err.stack);
        }
    }

    const handleJoyrideCallback = (data) => {
        const { status, type } = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            if (!user.guideTakenFor.includes("MakeSubscriptionPayment")) {
                AuthService.markVisited("MakeSubscriptionPayment");
                setUser({ ...user, guideTakenFor: [...user.guideTakenFor, "MakeSubscriptionPayment"] });
            }
            setTutorial({ ...tutorial, status: false });
        }
    };

    const getHelpers = (paramHelpers) => {
        helpers = paramHelpers;
    };

    // function's return
    return (
        <div id="makePaymentDiv">
            <ErrorBoundary errorAt="At Client MakeSubscriptionPayment Joyride">
                <Joyride
                    callback={handleJoyrideCallback}
                    continuous={true}
                    getHelpers={getHelpers}
                    run={tutorial.status}
                    scrollToFirstStep={true}
                    showProgress={true}
                    showSkipButton={true}
                    steps={tutorial.steps}
                    locale={{ last: 'Finish' }}
                    styles={{
                        options: {
                            primaryColor: "rgb(56, 78, 115)",
                            zIndex: 10000,
                        },
                    }}
                />
            </ErrorBoundary>
            <ErrorBoundary errorAt="At Client MakeSubscriptionPayment ClientNavbar">
                <ClientNavbar history={props.history} showTutorial={() => setTutorial({ ...tutorial, status: true })} />
            </ErrorBoundary>
            {
                isLoading ?
                    <img className="mx-auto d-block" height="auto" width="40%" src={Loading} alt="Loading..." />
                    :
                    <div className="p-3">

                        {/* Page Heading */}
                        <div>
                            <h1 id="make-payment" style={theme.headingBold}>Make Payment</h1>
                            <hr style={{ borderWidth: "2px" }} />
                        </div>

                        {/* Confirm Session Details */}
                        <div className="p-3">
                            <h2 id="confirm-subscription-details" style={theme.subHeadingSemibold}>Confirm Subscription Details</h2>
                            <hr />

                            <ErrorBoundary errorAt="At Client MakeSubscriptionPayment SelectedProvider">
                                <SelectedProvider
                                    selectedProvider={selectedProvider}
                                />
                            </ErrorBoundary>

                            <ErrorBoundary errorAt="At Client MakeSubscriptionPayment Table">
                                <Table borderless className="mt-4" id="subscriptionDetails">
                                    <tbody>
                                        <tr>
                                            <td style={{ minWidth: '10rem', width: '10rem' }}>
                                                <span id="subscription-plan" style={theme.h3HeadingSemibold}>Subscription Plan</span>
                                            </td>
                                            <td>
                                                <span id="subscription-plan-value" style={theme.paragraphMDSM}>{subscriptionDetails.name}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span id="call-sessions" style={theme.h3HeadingSemibold}>Call Sessions</span>
                                            </td>
                                            <td>
                                                <span  id="call-sessions-value" style={theme.paragraphMDSM}>{updateDetails.isUpdate ? `${updateDetails.call.new} total - ${updateDetails.call.old} used = ${updateDetails.call.remaining} remaining` : subscriptionDetails.call}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span id="video-sessions" style={theme.h3HeadingSemibold}>Video Sessions</span>
                                            </td>
                                            <td>
                                                <span id="video-sessions-value" style={theme.paragraphMDSM}>{updateDetails.isUpdate ? `${updateDetails.video.new} total -  ${updateDetails.video.old} used =  ${updateDetails.video.remaining} remaining` : subscriptionDetails.video}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span id="report-included" style={theme.h3HeadingSemibold}>Report Included</span>
                                            </td>
                                            <td>
                                                <span style={theme.paragraphMDSM}>{subscriptionDetails.report ? "Yes" : "No"}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span id="chat-sessions" style={theme.h3HeadingSemibold}>Chat Sessions</span>
                                            </td>
                                            <td>
                                                <span id="chat-sessions-values" style={theme.paragraphMDSM}>Unlimited</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span id="start-date" style={theme.h3HeadingSemibold}>Start Date</span>
                                            </td>
                                            <td>
                                                <span id="start-date-value" style={theme.paragraphMDSM}>{updateDetails.isUpdate ? moment.unix(updateDetails.currentCycleStartDate).format('MMM DD, dddd') : moment().format('MMM DD, dddd')}</span>
                                            </td>
                                        </tr>
                                        {
                                            updateDetails.isUpdate ?
                                                <tr>
                                                    <td>
                                                        <span style={theme.h3HeadingSemibold}>Days Passed</span>
                                                    </td>
                                                    <td className="d-flex">
                                                        <Progress className="successProgress my-auto mr-2" value={(100 * updateDetails.currentCycleDaysGone) / updateDetails.currentCycleTotalDays} /><span style={theme.paragraphMDSM}>{`${updateDetails.currentCycleDaysGone}/${updateDetails.currentCycleTotalDays}`}</span>
                                                    </td>
                                                </tr>
                                                : null
                                        }
                                    </tbody>
                                </Table>
                            </ErrorBoundary>
                        </div>

                        {/* Payment */}
                        <div className="p-3">
                            <h2 id="payment-heading" style={theme.subHeadingSemibold}>Payment</h2>
                            <hr />
                            <ErrorBoundary errorAt="At Client MakeSubscriptionPayment Table">
                                <Table borderless className="mt-4" id="finalCharges">
                                    {
                                        updateDetails.isUpdate ?
                                            <tbody>
                                                <tr>
                                                    <td style={{ minWidth: '12.5rem', width: '12.5rem' }}>
                                                        <span id="subscription-charges" style={theme.h3HeadingSemibold}>Subscription Charges</span>
                                                    </td>
                                                    <td>
                                                        <span style={theme.paragraphMDSM}>₹{Number(updateDetails.amount.new / 100).toFixed(2)}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ minWidth: '12.5rem', width: '12.5rem' }}>
                                                        <span id="current-balance" style={theme.h3HeadingSemibold}>Current Balance</span>
                                                    </td>
                                                    <td>
                                                        <span style={theme.paragraphMDSM}>₹{Number(updateDetails.amount.balanceAmount / 100).toFixed(2)}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span style={theme.h3HeadingSemibold}>GST({GST.percent}%)</span>
                                                    </td>
                                                    <td>
                                                        <span style={theme.paragraphMDSM}>₹{GST.amount}</span>
                                                    </td>
                                                </tr>
                                                {
                                                    totalAmount < 0 ?
                                                        <tr>
                                                            <td>
                                                                <span style={theme.h3HeadingSemibold}>Total Refund</span>
                                                            </td>
                                                            <td>
                                                                <span style={theme.paragraphMDSM}>₹{Math.abs(totalAmount + GST.amount).toFixed(2)}</span>
                                                            </td>
                                                        </tr>
                                                        :
                                                        <tr>
                                                            <td>
                                                                <span style={theme.h3HeadingSemibold}>Total Amount Due</span>
                                                            </td>
                                                            <td>
                                                                <span style={theme.paragraphMDSM}>₹{Number(totalAmount + GST.amount).toFixed(2)}</span>
                                                            </td>
                                                        </tr>
                                                }
                                            </tbody>
                                            :
                                            <tbody>
                                                <tr>
                                                    <td style={{ minWidth: '12.5rem', width: '12.5rem' }}>
                                                        <span style={theme.h3HeadingSemibold}>Subscription Charges</span>
                                                    </td>
                                                    <td>
                                                        <span style={theme.paragraphMDSM}>₹{Number(totalAmount).toFixed(2)}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span style={theme.h3HeadingSemibold}>GST({GST.percent}%)</span>
                                                    </td>
                                                    <td>
                                                        <span style={theme.paragraphMDSM}>₹{GST.amount}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span style={theme.h3HeadingSemibold}>Total Amount Due</span>
                                                    </td>
                                                    <td>
                                                        <span style={theme.paragraphMDSM}>₹{Number(totalAmount + GST.amount).toFixed(2)}</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                    }
                                </Table>
                            </ErrorBoundary>
                        </div>

                        <ErrorBoundary errorAt="At Client MakeSubscriptionPayment BookBtn">
                            <button className="btn my-2" style={theme.button} disabled={disableSubmitBtn} onClick={updateDetails.isUpdate ? handlePlanUpdate : handlePlanSelect} id="bookBtn">
                                {
                                    totalAmount < 0 ?
                                        `Request refund ₹${Math.abs(totalAmount + GST.amount).toFixed(2)}`
                                        : `Pay ₹${Number(totalAmount + GST.amount).toFixed(2)}`
                                }
                            </button>
                        </ErrorBoundary>
                        <br />
                        <text id="payments-notice">*Payments are powered by Razorpay</text>
                    </div >
            }
        </div >
    )
}
export default MakeSubscriptionPayment;